import * as React from "react";
const SvgFiRrCodePullRequest = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-code-pull-request_svg__a)">
      <path
        fill="#062147"
        d="M8 5c0-2.206-1.794-4-4-4S0 2.794 0 5a4.01 4.01 0 0 0 3 3.873v7.253A4.01 4.01 0 0 0 0 20c0 2.206 1.794 4 4 4s4-1.794 4-4a4.01 4.01 0 0 0-3-3.873V8.873A4.01 4.01 0 0 0 8 5M2 5c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2-2-.897-2-2m4 15c0 1.103-.897 2-2 2s-2-.897-2-2 .897-2 2-2 2 .897 2 2m15-3.873V9c0-2.757-2.243-5-5-5h-3.471l2.196-2.31A1 1 0 0 0 13.276.31L10.88 2.833c-1.17 1.17-1.17 3.073-.03 4.212l2.415 2.631a.997.997 0 0 0 1.412.061 1 1 0 0 0 .061-1.413L12.605 6h3.397c1.654 0 3 1.346 3 3v7.127a4.006 4.006 0 0 0-3 3.873c0 2.206 1.794 4 4 4s4-1.794 4-4a4.006 4.006 0 0 0-3-3.873zM20 22c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-code-pull-request_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCodePullRequest;
